"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.message = exports.MessageComponent = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_dom_1 = tslib_1.__importStar(require("react-dom"));
var config_context_1 = require("../_util/config-context");
var icon_1 = require("../icon");
var configprovider_1 = require("../configprovider");
var use_visible_transition_1 = require("../_util/use-visible-transition");
var call_both_1 = require("../_util/call-both");
var noop_1 = require("../_util/noop");
var util_1 = require("./util");
var use_isomorphic_layout_effect_1 = require("../_util/use-isomorphic-layout-effect");
var inject_value_1 = require("../_util/inject-value");
var Message = react_1.forwardRef(function MessageShow(_a, ref) {
    var type = _a.type, content = _a.content, _b = _a.duration, duration = _b === void 0 ? 3000 : _b, className = _a.className, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.onClose, onClose = _d === void 0 ? noop_1.noop : _d, popupContainer = _a.popupContainer;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _e = tslib_1.__read(react_1.useState(false), 2), visible = _e[0], setVisible = _e[1];
    react_1.useImperativeHandle(ref, function () { return ({ setVisible: setVisible }); });
    var timerRef = react_1.useRef(null);
    // 渲染之后，马上显示
    react_1.useEffect(function () {
        setVisible(true);
        return function () { return clearTimeout(timerRef.current); };
    }, []);
    use_isomorphic_layout_effect_1.useIsomorphicLayoutEffect(function () {
        clearTimeout(timerRef.current);
        if (visible && duration !== 0) {
            timerRef.current = setTimeout(function () { return setVisible(false); }, duration);
        }
    }, [duration, visible]);
    var _f = use_visible_transition_1.useVisibleTransition(visible), shouldContentEnter = _f.shouldContentEnter, shouldContentRender = _f.shouldContentRender, onContentExit = _f.onContentExit;
    if (!shouldContentRender) {
        return null;
    }
    var message = (react_1.default.createElement(util_1.MessageTransition, { in: shouldContentEnter, onExited: call_both_1.callBoth(onClose, onContentExit) },
        react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-toast", className), style: tslib_1.__assign({ zIndex: 1100 }, style), onMouseEnter: function () { return clearTimeout(timerRef.current); }, onMouseLeave: function () {
                if (duration !== 0) {
                    timerRef.current = setTimeout(function () { return setVisible(false); }, duration);
                }
            } },
            react_1.default.createElement(icon_1.Icon, { type: type }),
            react_1.default.createElement("span", null, content))));
    return react_dom_1.createPortal(message, inject_value_1.injectValue(popupContainer)() || util_1.getRoot(classPrefix));
});
Message.displayName = "Message";
exports.MessageComponent = Message;
var configStore = {};
var showMethod;
/**
 * API 的方式显示通知
 */
function show(type, _a) {
    if (type === void 0) { type = "success"; }
    if (_a === void 0) { _a = { content: "" }; }
    var _b = _a.onClose, onClose = _b === void 0 ? noop_1.noop : _b, options = tslib_1.__rest(_a, ["onClose"]);
    if (typeof showMethod === "function") {
        return showMethod(type, options);
    }
    var el = document.createElement("div");
    var instanceRef = react_1.default.createRef();
    react_dom_1.default.render(react_1.default.createElement(configprovider_1.ConfigProvider, null,
        react_1.default.createElement(Message, tslib_1.__assign({}, options, configStore, { type: type, ref: instanceRef, onClose: function () {
                onClose();
                react_dom_1.unmountComponentAtNode(el);
            } }))), el);
    var hide = function () {
        if (instanceRef.current) {
            instanceRef.current.setVisible(false);
        }
    };
    var handle = {
        hide: hide,
        destroy: hide,
    };
    util_1.limit(handle);
    return handle;
}
exports.message = {
    success: function (options) { return show("success", options); },
    warning: function (options) { return show("warning", options); },
    error: function (options) { return show("error", options); },
    loading: function (options) { return show("loading", options); },
    config: function (config) {
        if (config === void 0) { config = {}; }
        configStore = tslib_1.__assign({}, config);
    },
};
// eslint-disable-next-line dot-notation
exports.message["setShowMethod"] = function (method) {
    showMethod = method;
};
//# sourceMappingURL=Message.js.map